import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router' ;

import { ApiService } from '../../custom-material/Services/';
import { BuildingModel, BuildingTypeModel, DiagnosticModel, UserModel, IncidentModel } from '../../main/Models/';


@Component({
  selector: 'building-listitem',
  templateUrl: './t_building-list-item.component.html',
  styleUrls: ['./building-list-item.component.less']
})
export class BuildingListItemComponent implements OnInit {

  @Input()
  model: BuildingModel;

  @Output()
  displayTriggered: EventEmitter<BuildingModel> = new EventEmitter();

  constructor() { }

  ngOnInit() {}
}
